export const FuncionaisData = [
  {
    primeiroNome: 'xxx#lang',
    segundoNome: 'www.maersk.com.cn',
    finalidade:
      'Coleta informações sobre os usuários e suas atividades no site, que é usado para fornecer atendimento personalizado ao cliente e conteúdo.',
    validade: 'Session',
    processadorDados: 'Sitecore',
    linkPolitica: 'https://www.sitecore.com/trust/privacy-policy',
  },
  {
    primeiroNome: 'receive-cookie-deprecation',
    segundoNome: '.doubleclick.net',
    finalidade: 'Suporta a integração de uma plataforma de terceiros no site.',
    validade: '6 meses',
    processadorDados: 'Adform',
    linkPolitica:
      'https://site.adform.com/privacy-center/platform-privacy/product-and-services-privacy-policy',
  },
  {
    primeiroNome: 'receive-cookie-deprecation',
    segundoNome: '.adnxs.com',
    finalidade: 'Suporta a integração de uma plataforma de terceiros no site.',
    validade: 'um ano',
    processadorDados: 'Adform',
    linkPolitica:
      'https://site.adform.com/privacy-center/platform-privacy/product-and-services-privacy-policy',
  },
  {
    primeiroNome: 'xxx#lang',
    segundoNome: '.maersk.com',
    finalidade:
      'Coleta informações sobre os usuários e suas atividades no site, que é usado para fornecer atendimento personalizado ao cliente e conteúdo.',
    validade: 'um ano',
    processadorDados: 'Sitecore',
    linkPolitica: 'https://www.sitecore.com/trust/privacy-policy',
  },
  {
    primeiroNome: 'xxx#lang',
    segundoNome: 'www.maersk.com',
    finalidade:
      'Coleta informações sobre os usuários e suas atividades no site, que é usado para fornecer atendimento personalizado ao cliente e conteúdo.',
    validade: 'Session',
    processadorDados: 'Sitecore',
    linkPolitica: 'https://www.sitecore.com/trust/privacy-policy',
  },
  {
    primeiroNome: 'xxx#lang',
    segundoNome: 'auth.maersk.com',
    finalidade:
      'Coleta informações sobre os usuários e suas atividades no site, que é usado para fornecer atendimento personalizado ao cliente e conteúdo.',
    validade: 'Session',
    processadorDados: 'Sitecore',
    linkPolitica: 'https://www.sitecore.com/trust/privacy-policy',
  },
  {
    primeiroNome: 'ar_debug',
    segundoNome: '.doubleclick.net',
    finalidade:
      'Coleta informações sobre os usuários e suas atividades no site, que é usado para fornecer atendimento personalizado ao cliente e conteúdo.',
    validade: 'um mês',
    processadorDados: 'Google',
    linkPolitica:
      'https://policies.google.com/technologies/partner-sites?hl=en',
  },
  {
    primeiroNome: 'xxx#lang',
    segundoNome: 'beta.maersk.com.cn',
    finalidade:
      'Coleta informações sobre os usuários e suas atividades no site, que é usado para fornecer atendimento personalizado ao cliente e conteúdo.',
    validade: 'Session',
    processadorDados: 'Sitecore',
    linkPolitica: 'https://www.sitecore.com/trust/privacy-policy',
  },
  {
    primeiroNome: 'BrowserId',
    segundoNome: '.force.com',
    finalidade:
      'Coleta informações sobre os usuários e suas atividades no site. As informações são usadas para analisar o comportamento do usuário e fornecer conteúdo personalizado.',
    validade: 'um ano',
    processadorDados: 'Salesforce',
    linkPolitica: 'https://www.salesforce.com/eu/company/privacy',
  },
  {
    primeiroNome: 'xxx#lang',
    segundoNome: 'beta.maersk.com',
    finalidade:
      'Coleta informações sobre os usuários e suas atividades no site, que é usado para fornecer atendimento personalizado ao cliente e conteúdo.',
    validade: 'Session',
    processadorDados: 'Sitecore',
    linkPolitica: 'https://www.sitecore.com/trust/privacy-policy',
  },
]
